import { FC } from 'react'
import { GlobalStyles } from '@mui/material'

import { appConfig } from '$utils'

// The @loadedhub widgets size everything off this unit. Mercury's root font
// is 10px, so 1rem keeps them at the size they were designed for.
const widgetUnit = { '--loaded-ui-unit': '1rem' }

// Where the React content sits in the AngularJS page: under the fixed topbar,
// the wrapper's 1px border and 10px of padding (loaded.less). Below 1200px the
// wrapper pads 50px, not the topbar's 52px.
const hostSizes = {
  '--loaded-topbar-height': '52px',
  '--loaded-content-top': '61px',
  '--loaded-page-bottom-gap': '11px',
  '@media (min-width: 1200px)': {
    '--loaded-topbar-height': '64px',
    '--loaded-content-top': '75px',
  },
}

// Standalone renders no topbar and no AngularJS page.
const standaloneSizes = {
  '--loaded-topbar-height': '0px',
  '--loaded-content-top': '0px',
  '--loaded-page-bottom-gap': '0px',
}

/**
 * App-wide CSS variables: the widget unit and the sizes behind
 * `theme.loaded.hostLayout`. On :root because widgets portal dialogs and
 * toasts to document.body.
 */
const AppGlobalStyles: FC = () => (
  <GlobalStyles
    styles={{
      ':root': {
        ...widgetUnit,
        ...(appConfig.get<boolean>('standalone') ? standaloneSizes : hostSizes),
      },
      // The react-page layout drops the top padding on #content.
      '#wrapper.react-page #page-content-wrapper.no-sidenav': {
        '--loaded-content-top': '51px',
        '@media (min-width: 1200px)': { '--loaded-content-top': '65px' },
      },
    }}
  />
)

export default AppGlobalStyles
